import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import store from './store/store'

import Dashboard from './pages/Dashboard';
import StopCovid from './pages/StopCovid';
import OrderStatus from './pages/OrderStatus'
import PollAnswers from './pages/PollAnswers'
import ReferralForInterview from "./pages/ReferralForInterview"
import QRForSelfrecord from './pages/QRForSelfrecord'


export default new VueRouter({
    routes: [
        {
            path: '/stop-covid/*',
            name: 'order',
            component: OrderStatus,
            async beforeEnter(to, from, next) {
                let url = window.location;
                let source = url.hash.substr(2);
                let query = source.split('/');
                store.commit('SET_LINK_ORDER', query[1], { root: true });
                await store.dispatch('order/getOrderRoute');
                next()
                store.dispatch('order/query');
            }
        },
        {
            path: '/',
            redirect: StopCovid
        },
        {
            path: '/stop-covid',
            name: 'stop-covid',
            component: StopCovid,
            beforeEnter(to, from, next) {
                if (!from.name && store.state.checked) {
                    next({ 
                        name: 'dashboard', 
                        params: { id_login: store.state.userData.id_login }
                    })
                } 
                else if (from.name === 'dahsboard' || from.name === 'order') {
                    next();
                    // store.dispatch('covid/getReportSK');
                    // store.dispatch('covid/getReportArea');
                    // store.dispatch('covid/getReportOrder');
                } else {
                    next();
                    // store.dispatch('covid/getReportSK');
                    // store.dispatch('covid/getReportArea');
                    // store.dispatch('covid/getReportOrder');
                }
            }
        },
        
        {
            path: '/:id_login',
            name: 'dashboard',
            component: Dashboard,
            beforeEnter(to, from, next) {
                next()
                if (!store.state.checked) {
                    next({
                        name: 'stop-covid'
                    })
                }
                store.dispatch('covid/getVaccinCovidBranches');
            }
        },

        {
            path: '/interview',
            name: 'interview-wizard',
            component: PollAnswers,
            beforeEnter(to, from, next) {
                next();
            }
        },
        {
            path: '/:id_login/selfrecord',
            name: 'qr-for-selfrecord',
            component: QRForSelfrecord,
            beforeEnter(to, from, next) {
                next();
            }
        },
        {
            path: '/referral-for-interview',
            name: 'referral-for-interview',
            component: ReferralForInterview,
            beforeEnter(to, from, next) {
                next();
            }
        }
    ]
});




// WEBPACK FOOTER //
// ./src/router.js